import { Link } from '@tanstack/react-router';
import type { ReactNode } from 'react';

export function PageHeader({
  title,
  subtitle,
  back,
  action,
}: {
  title: string;
  subtitle?: ReactNode;
  back?: { to: string; label: string; params?: Record<string, string> };
  action?: ReactNode;
}) {
  return (
    <header className="mb-5 space-y-2">
      {back && (
        <Link
          to={back.to}
          params={back.params}
          className="inline-flex min-h-11 items-center text-sm font-medium text-link"
        >
          <svg aria-hidden width="16" height="16" viewBox="0 0 24 24" className="mr-1">
            <path
              d="M15 6l-6 6 6 6"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          {back.label}
        </Link>
      )}
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <h1 className="text-2xl font-bold text-text [overflow-wrap:anywhere]">{title}</h1>
          {subtitle && <p className="mt-1 text-text-muted">{subtitle}</p>}
        </div>
        {action}
      </div>
    </header>
  );
}

export function Section({
  title,
  action,
  children,
}: {
  title: string;
  action?: ReactNode;
  children: ReactNode;
}) {
  return (
    <section className="space-y-3">
      <div className="flex items-center justify-between">
        <h2 className="text-lg font-semibold text-text">{title}</h2>
        {action}
      </div>
      {children}
    </section>
  );
}
